import React, { useEffect } from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => ({ isCeiling, ...props }) => {
  const [, , , { clear: clearZones }] = hooks.useModelSearch('zone', 'get', {
    initial_filter: {}
  })

  useEffect(() => {
    return () => clearZones()
  }, [])

  const mergedProps = {
    isCeiling
  }

  return (
    <Component {...mergedProps} />
  )
}
export default withContainer
